<script setup lang="ts" name="SharedShipmentPreview">
import BaseItem from '~/components/BaseItem.vue';
import OrganisationShipmentPortContactsCard from '~/components/OrganisationShipmentPortContactsCard.vue';
import ServiceCard from '~/components/ServiceCard.vue';
import SharedShipmentCard from '~/components/SharedShipmentCard.vue';
import VesselMap from '~/components/VesselMap.vue';
import VoyageTracker from '~/components/VoyageTracker.vue';

import type {
  IBaseItem,
  ISharedContactCard,
  IVesselVoyageData,
  IVoyageTrackerStep,
} from '~/types';

defineProps<{
  serviceState: any;
  trackingService: any;
  vesselVoyageData?: IVesselVoyageData;
  shipmentInfo?: IBaseItem[];
  portsAndDates?: IVoyageTrackerStep[];
  portsAndDatesTooltip?: string;
  portContacts?: ISharedContactCard;
}>();
</script>

<template>
  <div class="w-full max-w-5xl space-y-2">
    <slot name="header" />
    <div class="w-full space-y-2">
      <ServiceCard
        v-bind="serviceState"
        notAvailableTitle="Shipment is No Longer Available"
        :auth-message="null"
        :auth-button="null"
      >
        <SharedShipmentCard title="Shipment Information">
          <template #actions>
            <slot />
          </template>

          <div
            class="grid grid-cols-2 grid-rows-2 gap-x-4 gap-y-1 sm:grid-cols-3 sm:grid-rows-1 sm:gap-y-0 lg:grid-cols-4"
          >
            <div v-for="item in shipmentInfo" :key="item.key">
              <BaseItem v-bind="item" />
            </div>
          </div>
        </SharedShipmentCard>

        <div class="flex flex-1 flex-col gap-2 sm:flex-row">
          <SharedShipmentCard
            title="Ports & Dates"
            :tooltipDescription="portsAndDatesTooltip"
            class="flex-1"
          >
            <div>
              <VoyageTracker
                v-for="port in portsAndDates"
                :key="port.id"
                v-bind="port"
              />
            </div>
          </SharedShipmentCard>

          <SharedShipmentCard title="Vessel Location" class="flex-1">
            <div class="h-[350px]">
              <VesselMap
                :serviceState="trackingService"
                :mapData="vesselVoyageData"
              />
            </div>
          </SharedShipmentCard>
        </div>

        <div class="rounded-md border border-charcoal-0">
          <OrganisationShipmentPortContactsCard v-bind="portContacts" />
        </div>
      </ServiceCard>
    </div>
  </div>
</template>
